import { render } from "./MainBranch.vue?vue&type=template&id=00689da8&scoped=true"
import script from "./MainBranch.vue?vue&type=script&lang=js"
export * from "./MainBranch.vue?vue&type=script&lang=js"

import "./MainBranch.vue?vue&type=style&index=0&id=00689da8&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00689da8"]])

export default __exports__